import { Component, HostListener, inject, signal, ViewChild } from '@angular/core';
import { RouterOutlet } from '@angular/router';
import { Navbar } from './core/shared/components/navbar/navbar';
import { MatDrawer, MatSidenavModule } from '@angular/material/sidenav';
import { SideMenu } from './core/shared/components/side-menu/side-menu';

@Component({
  selector: 'dnv-root',
  imports: [
    RouterOutlet, 
    Navbar, 
    MatSidenavModule, 
    SideMenu],
  templateUrl: './app.html',
  styleUrl: './app.scss',
  standalone: true,
})
export class App {
  @ViewChild('navbar') navbar!: Navbar;
  @ViewChild('drawer') drawer!: MatDrawer;
  protected readonly title = signal('pns-frontend');

  onMenuToggle(): void {
    this.drawer.toggle();
  }

  @HostListener('window:keydown.enter', ['$event'])
  handleGlobalEnter(event: KeyboardEvent): void {
    const target = event.target as HTMLElement | null;
    const tag = (target?.tagName || '').toLowerCase();
    const isTextInput = tag === 'input' || tag === 'textarea' || target?.isContentEditable;

    if (isTextInput) {
      return;
    }

    if (this.navbar) {
      this.navbar.focusSearchbar();
    }
  }

}
